import "init/jiffy";
import "common/base";
import "common/utils/remote-image";

/* us */
import "components/jiffy/canada-redirect-modal/canada-redirect-modal";
import "components/jiffy/free-shipping-banner/free-shipping-banner";
import "components/jiffy/masthead/masthead";
import initMastheadRedesign2025 from "components/jiffy/masthead-redesign2025/masthead-redesign2025";
import initProductsFilter from "components/jiffy/products-filter/products-filter";
import "components/jiffy/price-line-through/price-line-through";
import "components/jiffy/app-store-badge/app-store-badge";
import initDropdownColors from "components/jiffy/dropdown-colors/dropdown-colors";
import initJiffyFirstBadges from "components/j1_badge/component";

/* application_head */
import "components/jiffy/promo-banner-list/promo-banner-list";
import "components/jiffy/promo-banner/promo-banner";
import "components/jiffy/button-box/button-box";
import "components/jiffy/text-box/text-box";
import "components/jiffy/check-box/check-box";
import "components/jiffy/input-box/input-box";
import "components/jiffy/radio-box/radio-box";
import "components/jiffy/flash-messages/flash-messages";
import "components/jiffy/wholesale-pricing-toast/wholesale-pricing-toast";
import "components/jiffy/wholesale-inquiry/wholesale-inquiry";

/* application */
import initAccessibility from "common/jiffy/accessibility";
import initModalWrapper from "components/jiffy/modal-wrapper/modal-wrapper";
import initProducts from "components/jiffy/products/products";
import initProductsBrands from "components/jiffy/products-brands/products-brands";
import initSiteJabber from "components/jiffy/site-jabber-carousel/site-jabber-carousel";
import initSocialLinks from "components/jiffy/social-icons/social-icons";
import initSoftnessScore from "components/compositions/softness_score/component";
import initSatisfactionGuaranteed from "components/compositions/satisfaction_guaranteed/component";
import "components/jiffy/jiffy-pagination/jiffy-pagination";
import "components/jiffy/shipment-delivery/shipment-delivery";
import "components/jiffy/site-jabber/site-jabber";
import "components/spinner/component.scss";
import "components/jiffy/notification-alert/notification-alert";
import "components/jiffy/stars/stars";
import "components/jiffy/product-details-badges-carousel/product-details-badges-carousel";
import "components/kit/breadcrumbs/component";
import initGlobalStartDesigning from "common/jiffy/start-designing-global";
import initPLPTransfer from "components/jiffy/product-card-transfers/product-card-transfers";
import initSeoModifications from "common/jiffy/seo-modifications";

/* app registry */
import appRegistry from "common/utils/app-registry";
import { waitForImage } from "common/utils/ui/wait_for";

appRegistry.register("app", () => {
  initAccessibility();
  initDropdownColors();
  initModalWrapper();
  initSiteJabber();
  initSoftnessScore();
  initGlobalStartDesigning();
  initSeoModifications();
  initSatisfactionGuaranteed();
  initMastheadRedesign2025();
  initProductsFilter();

  if (document.querySelector(".js-jiffy-first-badge")) initJiffyFirstBadges();
  if (document.querySelector(".js-products-brands")) initProductsBrands();
  if (document.querySelector(".js-products")) initProducts();
  if (document.querySelector(".js-social-link")) initSocialLinks();
  if (document.querySelector(".js-product-card-transfers")) initPLPTransfer();
});

appRegistry.register("assets", async () => {
  const criticalImagesSelectors = [
    ".js-header-promo-banner img",
    ".js-carousel-image",
    ".free-shipping-banner img"
  ];
  await Promise.all(criticalImagesSelectors.map(selector => waitForImage(selector)));
});
